<template>
  <div class="qr-dialog-overlay">
    <div class="qr-dialog">
      <button id="close-btn" @click="closeScanner">✖</button>
      <div class="qr-box"></div>
      <div id="reader"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, nextTick } from "vue";
import { Html5Qrcode } from "html5-qrcode";
import UtilMixin from "@/common/mixins/UtilMixin";

export default defineComponent({
  name: "QRScannerDialog",
  emits: ["qrScanned", "close"],
  setup() {
    return {};
  },

  data() {
    return {
      visible: false, // ✅ 다이얼로그 표시 여부
      scanner: null as Html5Qrcode | null,
    };
  },
  mixins: [UtilMixin],
  computed: {
    //
  },
  methods: {
    async openScanner() {
      this.visible = true;
      document.body.style.overflow = "hidden"; // ✅ 스크롤 막기
      await nextTick();
      this.startScanner();
    },

    // ✅ QR 스캐너 시작
    async startScanner() {
      if (!document.getElementById("reader")) {
        alert("❌ #reader 요소를 찾을 수 없습니다.");
        return;
      }
      this.scanner = new Html5Qrcode("reader");
      // alert("✅ Html5Qrcode 인스턴스 생성됨");

      try {
        const cameras = await Html5Qrcode.getCameras();
        if (cameras.length > 0) {
          // alert(cameras[cameras.length - 1].label);
          const cameraId = cameras[cameras.length - 1].id;

          await this.scanner.start(
            cameraId,
            {
              fps: 10,
              qrbox: undefined, // ✅ 전체화면 적용
              videoConstraints: { facingMode: "environment" }, // ✅ 후면 카메라
            },
            (decodedText: string) => {
              console.log("✅ QR 코드 스캔 성공:", decodedText);
              this.$emit("qrScanned", decodedText); // ✅ 부모에게 데이터 전달
              this.closeScanner();
            },
            (errorMessage: any) => {
              console.warn("⚠️ QR 코드 스캔 실패:", errorMessage);
            }
          );
          // alert("카메라 시작 완료");
        } else {
          console.error("❌ 카메라를 찾을 수 없습니다.");
          alert("카메라를 찾을 수 없습니다");
          // this.closeScanner();
        }
      } catch (error) {
        console.error("❌ 카메라 접근 오류:", error);
        alert("카메라 접근 오류");
        // this.closeScanner();
      }
    },

    // ✅ QR 스캔 종료
    async closeScanner() {
      try {
        if (this.scanner) {
          await this.scanner.stop();
          this.scanner.clear();
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.visible = false;
        document.body.style.overflow = "auto"; // ✅ 스크롤 복구
        this.$emit("close"); // ✅ 부모에게 닫힘 이벤트 전달
        console.log("📴 카메라 종료됨");
      }
    },
  },

  async mounted() {
    console.log("---- scanner mounted -----");
    this.openScanner();
    setTimeout(async () => {
      // await nextTick();
      // this.openScanner();
    }, 1000);
  },
  updated() {
    console.log("---- scanner updated -----");
  },
});
</script>

<style lang="scss" scoped>
/* ✅ 기본적으로 PC에서는 `overlay` 사용 */
.qr-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6); /* 🔥 PC에서는 어두운 배경 */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* ✅ 카메라 화면 크기 및 위치 조정 */
.qr-dialog {
  position: relative;
  width: 100%;
  max-width: 500px; /* 🔥 PC에서는 크기 조정 */
  height: 500px;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  overflow: hidden; /* 🔥 카메라 화면이 넘치지 않도록 */
}

/* ✅ 카메라 화면을 가득 차게 설정 (모바일 적용) */
#reader {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

/* ✅ 닫기(X) 버튼: 항상 보이게 설정 */
#close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  color: white;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  padding: 5px 10px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10000;
}

/* ✅ QR 코드 스캔 네모 박스 */
.qr-box {
  position: absolute;
  width: 250px;
  height: 250px;
  border: 3px solid white;
  z-index: 1000;
  pointer-events: none;
  box-shadow: 0px 0px 0px 100vw rgba(0, 0, 0, 0.6),
    /* 왼쪽 그림자 */ 0px 0px 0px 100vw rgba(0, 0, 0, 0.6),
    /* 오른쪽 그림자 */ 0px 100vh 0px 0px rgba(0, 0, 0, 0.6),
    /* 위쪽 그림자 */ 0px -100vh 0px 0px rgba(0, 0, 0, 0.6); /* 아래쪽 그림자 */
}

/* ✅ 모바일에서 전체화면 적용 */
@media (max-width: 768px) {
  .qr-dialog-overlay {
    background-color: transparent !important; /* ✅ 배경 제거 */
  }

  .qr-dialog {
    width: 100vw;
    height: 100vh;
    max-width: 100vw;
    max-height: 100vh;
    border-radius: 0;
    background: transparent;
  }

  #reader {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
  }

  /* ✅ 모바일에서는 닫기 버튼 위치 조정 */
  #close-btn {
    top: 20px;
    right: 20px;
  }

  /* ✅ 모바일에서 QR 스캔 영역 크기 조정 */
  .qr-box {
    width: 60vw;
    height: 60vw;
    border: 3px solid white;
  }
}
</style>
